import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../../hooks/useAuth.js';
import { Spinner } from '../../components/ui/Spinner.js';

interface RequireAdminProps {
  readonly children: ReactNode;
}

export function RequireAdmin({ children }: RequireAdminProps): JSX.Element {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return <Spinner showLabel label="Checking session…" className="text-slate-500" />;
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
